import { createSlice } from "@reduxjs/toolkit";
import {
  deleteDeduction,
  deleteDeductionCategory,
  loadAllDeductionCategories,
  loadDeduction,
  loadDeductionCategory,
  loadDeductionCategories,
  loadDeductions,
  saveDeduction,
  saveDeductionCategory,
  updateDeduction,
  updateDeductionCategory,
  loadDeductionSettings,
  loadDeductionSetting,
  addDeductionSetting,
  updateDeductionSetting,
  deleteDeductionSetting,
  loadAllDeductions,
  loadEmployeeAssignedDeduction,
  deleteDeductionFromEmployee,
  disableDeductionFromEmployee,
  assignDeductionToEmployee,
  loadAllBonuses,
  assignBonusToEmployee,
  deleteBonusFromEmployee,
  disableBonusFromEmployee,
  loadEmployeeAssignedBonus,
  updateAssignedBonus,
  loadBackupHistory,
  recordBackup,
  downloadBackup,
  loadPaySlipHistory,
  loadAllPaySlipHistory,
  runPayRoll,
  loadEmployeePaySlipDetails,
  getPaySlipList,
  getContributionTypes,
  getSalaryTypes,
  loadCNPSReport,
  generateEmployeePayslip,

  //Bonus Settings
  loadBonusSettings,
  loadBonusSetting,
  addBonusSetting,
  updateBonusSetting,
  deleteBonusSetting,

  // Allowances
  loadAllAllowances,
  loadAllPaginatedAllowances,
  createAllowance,
  updateAllowance,
  deleteAllowance,
  loadAllowance,
  assignAllowanceToEmployee,
  deleteAllowanceFromEmployee,
  loadEmployeeAllowances,
  updateAssignedAllowance,
} from "./thunks";

export const initialState = {
  contributionTypes: [],
  salaryTypes: [],
  deductionCategories: [],
  deductionCategory: {},
  deductions: [],
  deductionList: [],
  assignedDeductions: [],
  deduction: {},
  bonuses: [],
  bonusList: [],
  assignedBonuses: [],
  bonus: {},
  deductionSettings: [],
  deductionSetting: {},
  responseJson: {},
  error: {},
  isUpdating: false,
  backupHistory: [],

  paySlipHistory: [],
  allPaySlipHistory: [],
  employeePaySlipDetails: {},
  paySlipList: [],
  cnpsReportByMonth: [],

  //Bonus Settings
  bonusSettings: [],
  bonusSetting: {},

  // allowances
  allowances: [],
  isAllowancesLoading: false,
  allowance: {},
  assignedAllowances: [],

  // Employee Allowances
  employeeAllowances: [],
  isEmployeeAllowancesLoading: false,
  assignedAllowances: [],
  isAssigningAllowance: false,
  isDeletingAllowance: false,
  isUpdatingAllowance: false,

};

const PayrollSlice = createSlice({
  name: "payroll",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    // Deduction Categories management
    builder.addCase(loadDeductionCategories.fulfilled, (state, action) => {
      state.error = null;
      state.deductionCategories = action.payload.data;
    });
    builder.addCase(loadDeductionCategories.rejected, (state, action) => {
      state.deductionCategories = [];
      state.error = action.error.message || null;
    });

    builder.addCase(loadAllDeductionCategories.fulfilled, (state, action) => {
      state.error = null;
      state.deductionCategories = action.payload.data;
    });
    builder.addCase(loadAllDeductionCategories.rejected, (state, action) => {
      state.deductionCategories = [];
      state.error = action.error.message || null;
    });


    builder.addCase(saveDeductionCategory.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(saveDeductionCategory.rejected, (state, action) => {
      state.responseJson = null;
      state.error = action.error.message || null;
    });

    builder.addCase(loadDeductionCategory.fulfilled, (state, action) => {
      state.error = null;
      state.deductionCategory = action.payload.data;
    });
    builder.addCase(loadDeductionCategory.rejected, (state, action) => {
      state.deductionCategory = null;
      state.error = action.error.message || null;
    });

    builder.addCase(updateDeductionCategory.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(updateDeductionCategory.rejected, (state, action) => {
      state.responseJson = null;
      state.error = action.error.message || null;
    });

    builder.addCase(deleteDeductionCategory.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(deleteDeductionCategory.rejected, (state, action) => {
      state.responseJson = null;
      state.error = action.error.message || null;
    });

    // Deductions management
    builder.addCase(loadDeductions.fulfilled, (state, action) => {
      state.error = null;
      state.deductions = action.payload.data;
    });
    builder.addCase(loadDeductions.rejected, (state, action) => {
      state.deductions = [];
      state.error = action.error.message || null;
    });
    builder.addCase(saveDeduction.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(saveDeduction.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    builder.addCase(loadDeduction.fulfilled, (state, action) => {
      state.error = null;
      state.deduction = action.payload.data;
    });
    builder.addCase(loadDeduction.rejected, (state, action) => {
      state.deduction = null;
      state.error = action.error.message || null;
    });

    builder.addCase(updateDeduction.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(updateDeduction.rejected, (state, action) => {
      state.responseJson = null;
      state.error = action.error.message || null;
    });

    builder.addCase(deleteDeduction.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(deleteDeduction.rejected, (state, action) => {
      state.responseJson = null;
      state.error = action.error.message || null;
    });

    // Deduction settings management
    builder.addCase(loadDeductionSettings.fulfilled, (state, action) => {
      state.error = null;
      state.deductionSettings = action.payload.data;
    });
    builder.addCase(loadDeductionSettings.rejected, (state, action) => {
      state.deductionSettings = [];
      state.error = action.error.message || null;
    });
    builder.addCase(addDeductionSetting.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(addDeductionSetting.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    builder.addCase(loadDeductionSetting.fulfilled, (state, action) => {
      state.error = null;
      state.deductionSetting = action.payload.data;
    });
    builder.addCase(loadDeductionSetting.rejected, (state, action) => {
      state.deductionSetting = null;
      state.error = action.error.message || null;
    });

    builder.addCase(updateDeductionSetting.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(updateDeductionSetting.rejected, (state, action) => {
      state.responseJson = null;
      state.error = action.error.message || null;
    });

    builder.addCase(deleteDeductionSetting.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(deleteDeductionSetting.rejected, (state, action) => {
      state.responseJson = null;
      state.error = action.error.message || null;
    });

    //load deductions without paginate

    builder.addCase(loadAllDeductions.fulfilled, (state, action) => {
      state.error = null;
      state.deductionList = action.payload.data;
    });
    builder.addCase(loadAllDeductions.rejected, (state, action) => {
      state.deductionList = [];
      state.error = action.error.message || null;
    });

    //load Assigned Deductions
    builder.addCase(
      loadEmployeeAssignedDeduction.fulfilled,
      (state, action) => {
        state.error = null;
        state.assignedDeductions = action.payload.data;
      },
    );
    builder.addCase(loadEmployeeAssignedDeduction.rejected, (state, action) => {
      state.assignedDeductions = [];
      state.error = action.error.message || null;
    });

    //assignDeductionToEmployee
    builder.addCase(assignDeductionToEmployee.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(assignDeductionToEmployee.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    //deleteDeductionFromEmployee
    builder.addCase(deleteDeductionFromEmployee.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(deleteDeductionFromEmployee.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    //disableDeductionFromEmployee
    builder.addCase(disableDeductionFromEmployee.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(disableDeductionFromEmployee.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    //Assign Bonuses reducer
    //load Bonuses without paginate

    builder.addCase(loadAllBonuses.fulfilled, (state, action) => {
      state.error = null;
      state.bonusList = action.payload.data;
    });
    builder.addCase(loadAllBonuses.rejected, (state, action) => {
      state.bonusList = [];
      state.error = action.error.message || null;
    });

    //assignBonusToEmployee
    builder.addCase(assignBonusToEmployee.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(assignBonusToEmployee.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    //loadEmployeeAssignedBonus
    builder.addCase(loadEmployeeAssignedBonus.fulfilled, (state, action) => {
      state.error = null;
      state.assignedBonuses = action.payload.data;
    });
    builder.addCase(loadEmployeeAssignedBonus.rejected, (state, action) => {
      state.assignedBonuses = [];
      state.error = action.error.message || null;
    });

    //deleteBonusFromEmployee
    builder.addCase(deleteBonusFromEmployee.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(deleteBonusFromEmployee.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    //disableBonusFromEmployee
    builder.addCase(disableBonusFromEmployee.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(disableBonusFromEmployee.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    //updateAssignedBonus
    builder.addCase(updateAssignedBonus.pending, (state) => {
      state.error = null;
      state.isUpdating = true;
    });
    builder.addCase(updateAssignedBonus.fulfilled, (state, action) => {
      state.error = null;
      state.isUpdating = false;
      state.responseJson = action.payload;
    });
    builder.addCase(updateAssignedBonus.rejected, (state, action) => {
      state.responseJson = {};
      state.isUpdating = false;
      state.error = action.error.message || "Erreur lors de la mise à jour";
    });

    //Help list
    builder.addCase(getContributionTypes.fulfilled, (state, action) => {
      state.error = null;
      state.contributionTypes = action.payload.data;
    });
    builder.addCase(getContributionTypes.rejected, (state, action) => {
      state.contributionTypes = [];
      state.error = action.error.message || null;
    });

    //salary types
    builder.addCase(getSalaryTypes.fulfilled, (state, action) => {
      state.error = null;
      state.salaryTypes = action.payload.data;
    });
    builder.addCase(getSalaryTypes.rejected, (state, action) => {
      state.salaryTypes = [];
      state.error = action.error.message || null;
    });
    //Backup
    builder.addCase(loadBackupHistory.fulfilled, (state, action) => {
      state.error = null;
      state.backupHistory = action.payload.data;
    });
    builder.addCase(loadBackupHistory.rejected, (state, action) => {
      state.backupHistory = [];
      state.error = action.error.message || null;
    });

    builder.addCase(recordBackup.fulfilled, (state, action) => {
      state.error = null
      state.responseJson = action.payload
    })
    builder.addCase(recordBackup.rejected, (state, action) => {
      state.responseJson = {}
      state.error = action.error.message || null
    })

    builder.addCase(downloadBackup.fulfilled, (state, action) => {
      state.error = null
      state.body = action.payload.data;
    })
    builder.addCase(downloadBackup.rejected, (state, action) => {
      state.body = null
      state.error = action.error.message || null
    })


    //payslip history
    builder.addCase(loadPaySlipHistory.fulfilled, (state, action) => {
      state.error = null;
      state.paySlipHistory = action.payload.data;
    });

    builder.addCase(loadPaySlipHistory.rejected, (state, action) => {
      state.paySlipHistory = [];
      state.error = action.error.message || null;
    });
    builder.addCase(loadAllPaySlipHistory.fulfilled, (state, action) => {
      state.error = null;
      state.allPaySlipHistory = action.payload.data;
    });

    builder.addCase(loadAllPaySlipHistory.rejected, (state, action) => {
      state.allPaySlipHistory = [];
      state.error = action.error.message || null;
    });

    //run payroll
    builder.addCase(runPayRoll.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload.data;
    });

    builder.addCase(runPayRoll.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    //generate employee payslip
    builder.addCase(generateEmployeePayslip.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });

    builder.addCase(generateEmployeePayslip.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    //employee payslip details
    builder.addCase(loadEmployeePaySlipDetails.fulfilled, (state, action) => {
      state.error = null;
      state.employeePaySlipDetails = action.payload.data;
    });

    builder.addCase(loadEmployeePaySlipDetails.rejected, (state, action) => {
      state.employeePaySlipDetails = {};
      state.error = action.error.message || null;
    });

    //payslip list
    builder.addCase(getPaySlipList.fulfilled, (state, action) => {
      state.error = null;
      state.paySlipList = action.payload.data;
    });

    builder.addCase(getPaySlipList.rejected, (state, action) => {
      state.paySlipList = [];
      state.error = action.error.message || null;
    });

    // CNPS Report
    builder.addCase(loadCNPSReport.fulfilled, (state, action) => {
      state.error = null;
      state.cnpsReportByMonth = action.payload.data;
    });
    builder.addCase(loadCNPSReport.rejected, (state, action) => {
      state.cnpsReportByMonth = [];
      state.error = action.error.message || null;
    });




    // Bonus Settings

    builder.addCase(loadBonusSettings.fulfilled, (state, action) => {
      state.error = null;
      state.bonusSettings = action.payload?.data || [];
    });

    builder.addCase(loadBonusSettings.rejected, (state, action) => {
      state.bonusSettings = [];
      state.error = action.error.message || null;
    });

    builder.addCase(loadBonusSetting.fulfilled, (state, action) => {
      state.error = null;
      state.bonusSetting = action.payload?.data || null;
    });

    builder.addCase(loadBonusSetting.rejected, (state, action) => {
      state.bonusSetting = null;
      state.error = action.error.message || null;
    });


    // ADD BONUS SETTING
    builder.addCase(addBonusSetting.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;

      // If API returns created object, update list immediately
      if (action.payload?.data) {
        state.bonusSettings.push(action.payload.data);
      }
    });

    builder.addCase(addBonusSetting.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });


    // UPDATE BONUS SETTING
    builder.addCase(updateBonusSetting.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;

      const updatedId = action.meta.arg.id;

      state.bonusSettings = state.bonusSettings.map((item) =>
        item.id === updatedId
          ? { ...item, ...action.meta.arg } // fallback update
          : item
      );
    });

    builder.addCase(updateBonusSetting.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });


    // DELETE BONUS SETTING
    builder.addCase(deleteBonusSetting.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;

      const deletedId = action.meta.arg.id;

      state.bonusSettings = state.bonusSettings.filter(
        (item) => item.id !== deletedId
      );
    });

    builder.addCase(deleteBonusSetting.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });

    // allowances
    builder.addCase(loadAllAllowances.fulfilled, (state, action) => {
      state.isAllowancesLoading = true;
      state.error = null;
      state.allowances = action.payload?.data || [];
      state.isAllowancesLoading = false;
    });
    builder.addCase(loadAllAllowances.rejected, (state, action) => {
      state.isAllowancesLoading = false;
      state.allowances = [];
      state.error = action.error.message || null;
    });
    builder.addCase(loadAllPaginatedAllowances.fulfilled, (state, action) => {
      state.isAllowancesLoading = true;
      state.error = null;
      state.allowances = action.payload?.data || [];
      state.isAllowancesLoading = false;
    });
    builder.addCase(loadAllPaginatedAllowances.rejected, (state, action) => {
      state.isAllowancesLoading = false;
      state.allowances = [];
      state.error = action.error.message || null;
    });
    builder.addCase(createAllowance.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(createAllowance.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });
    builder.addCase(updateAllowance.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(updateAllowance.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });
    builder.addCase(deleteAllowance.fulfilled, (state, action) => {
      state.error = null;
      state.responseJson = action.payload;
    });
    builder.addCase(deleteAllowance.rejected, (state, action) => {
      state.responseJson = {};
      state.error = action.error.message || null;
    });
    builder.addCase(loadAllowance.fulfilled, (state, action) => {
      state.error = null;
      state.allowance = action.payload?.data || null;
    });
    builder.addCase(loadAllowance.rejected, (state, action) => {
      state.allowance = null;
      state.error = action.error.message || null;
    });

    // Employee Allowances
    builder.addCase(loadEmployeeAllowances.fulfilled, (state, action) => {
      state.isEmployeeAllowancesLoading = true;
      state.error = null;
      state.employeeAllowances = action.payload?.data || [];
      state.isEmployeeAllowancesLoading = false;
    });
    builder.addCase(loadEmployeeAllowances.rejected, (state, action) => {
      state.isEmployeeAllowancesLoading = false;
      state.employeeAllowances = [];
      state.error = action.error.message || null;
    });
    builder.addCase(assignAllowanceToEmployee.fulfilled, (state, action) => {
      state.isAssigningAllowance = true;
      state.error = null;
      state.isAssigningAllowance = false;
    });
    builder.addCase(assignAllowanceToEmployee.rejected, (state, action) => {
      state.isAssigningAllowance = false;
      state.error = action.error.message || null;
    });
    builder.addCase(deleteAllowanceFromEmployee.fulfilled, (state, action) => {
      state.isDeletingAllowance = true;
      state.error = null;
      state.isDeletingAllowance = false;
    });
    builder.addCase(deleteAllowanceFromEmployee.rejected, (state, action) => {
      state.isDeletingAllowance = false;
      state.error = action.error.message || null;
    });
    builder.addCase(updateAssignedAllowance.fulfilled, (state, action) => {
      state.isUpdatingAllowance = true;
      state.error = null;
      state.isUpdatingAllowance = false;
    });
    builder.addCase(updateAssignedAllowance.rejected, (state, action) => {
      state.isUpdatingAllowance = false;
      state.error = action.error.message || null;
    });
  },
});

export default PayrollSlice.reducer;
